import React from "react";
import FormField, {
  helperTextStyle,
} from "../../../shared/ui/FormField";
import Input from "../../../shared/ui/Input";
import Select from "../../../shared/ui/Select";
import { AGE_OPTIONS, GENDER_OPTIONS } from "../constants/profileOptions";

function formatDateBR(value) {
  if (!value) return "";

  const normalized = String(value).trim();
  const match = normalized.match(/^(\d{4})-(\d{2})-(\d{2})$/);

  if (match) {
    const [, year, month, day] = match;
    return `${day}/${month}/${year}`;
  }

  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return value;

  try {
    return new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  } catch {
    return value;
  }
}

export default function ProfileAboutSection({
  isEditing,
  profile,
  setProfile,
  userName,
  imc,
}) {
  return (
    <section className="space-y-3">
      <div className="flex items-center gap-2 px-1">
        <span className="h-2 w-2 rounded-full bg-[#6C54D8]" />
        <h2 className="text-sm font-bold text-[#24152F] tracking-tight">
          Sobre Mim
        </h2>
      </div>

      <div className="liti-card transition-all duration-300 p-5 space-y-4">
        <div className="grid gap-4">
          {/* NOME COMPLETO DO CADASTRO (CAMPO A MAIS) */}
          <FormField
            label="Nome cadastrado"
            isEditing={false}
            readOnlyValue={userName || profile.fullName || "—"}
          />

          {/* NOME COMO QUER SER CHAMADO */}
          <FormField
            label="Como quer ser chamado*"
            isEditing={isEditing}
            readOnlyValue={profile.displayName || userName}
          >
            <Input
              placeholder="Como quer ser chamado(a)?"
              value={profile.displayName}
              onChange={(event) =>
                setProfile((prev) => ({
                  ...prev,
                  displayName: event.target.value,
                }))
              }
            />
          </FormField>

          <FormField
            label="Gênero*"
            isEditing={isEditing}
            readOnlyValue={profile.gender}
          >
            <Select
              value={profile.gender}
              onChange={(event) =>
                setProfile((prev) => ({
                  ...prev,
                  gender: event.target.value,
                }))
              }
              options={GENDER_OPTIONS}
            />
          </FormField>

          <FormField
            label="Faixa etária*"
            isEditing={isEditing}
            readOnlyValue={profile.ageRange}
          >
            <Select
              value={profile.ageRange}
              onChange={(event) =>
                setProfile((prev) => ({
                  ...prev,
                  ageRange: event.target.value,
                }))
              }
              options={AGE_OPTIONS}
            />
          </FormField>

          <FormField
            label="Altura (cm)*"
            isEditing={isEditing}
            readOnlyValue={profile.height}
            readOnlySuffix={profile.height ? " cm" : ""}
          >
            <Input
              type="number"
              placeholder="Ex: 165"
              value={profile.height}
              onChange={(event) =>
                setProfile((prev) => ({
                  ...prev,
                  height: event.target.value,
                }))
              }
            />
          </FormField>

          <FormField
            label="Peso inicial (kg)*"
            isEditing={isEditing}
            readOnlyValue={profile.startWeight}
            readOnlySuffix={profile.startWeight ? " kg" : ""}
          >
            <Input
              type="number"
              placeholder="Ex: 70"
              value={profile.startWeight}
              onChange={(event) =>
                setProfile((prev) => ({
                  ...prev,
                  startWeight: event.target.value,
                }))
              }
            />
          </FormField>

          <FormField
            label="Data da pesagem*"
            isEditing={isEditing}
            readOnlyValue={formatDateBR(profile.startWeightDate)}
            preserveSpacingWhenReadonly
          >
            <Input
              type="date"
              value={profile.startWeightDate}
              onChange={(event) =>
                setProfile((prev) => ({
                  ...prev,
                  startWeightDate: event.target.value,
                }))
              }
            />
          </FormField>

          {isEditing && <p style={helperTextStyle}>*Campos obrigatórios</p>}

          <div className="mt-1 rounded-2xl bg-[#ECE7FA] p-4 text-center border border-[#ECE7FA] shadow-xs">
            <p className="text-[10px] font-bold uppercase tracking-wider text-[#6C54D8]">
              IMC Inicial Calculado
            </p>

            <p className="text-3xl font-black text-[#24152F] mt-1 font-serif">
              {imc || "—"}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}